<div id="checkout-make-payments">
  <router-outlet></router-outlet>
</div>
<div id="payment-footer-container" *ngIf="(this.paymentRule$ | async) !== null">
  <payment-footer-container> </payment-footer-container>
</div>
